/**
 * Normalize rich-text-editor HTML for email rendering.
 *
 * The shared HtmlEditor hard-codes `margin: 0` on every paragraph, so paragraphs render flush
 * (no separation) and empty paragraphs collapse — meaning pressing Enter for blank lines is lost
 * in both the preview and the delivered email. This restores proper paragraph spacing (inline, so
 * it survives email clients that strip <style>) and turns empty paragraphs into visible blank lines.
 *
 * Idempotent — safe to apply more than once (preview + send).
 */
export function normalizeEmailHtml(html?: string | null): string {
  if (!html) return '';
  return html
    // Paragraph separation: the editor emits `margin: 0; line-height: 1.5;` on every <p>.
    .replace(/margin:\s*0;\s*line-height:\s*1\.5;?/gi, 'margin: 0 0 1em; line-height: 1.5;')
    // Empty paragraphs → a visible blank line (a <p> with only whitespace/&nbsp; collapses).
    .replace(/<p((?:\s[^>]*)?)>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '<p$1><br></p>');
}
